<template>
  <todays-order-history />
</template>
<script>
import { mapGetters } from 'vuex'
import TodaysOrderHistory from '@/components/orderHistory/TodaysOrderHistory'
export default {
  components: {
    TodaysOrderHistory,
  },
  computed: {
    ...mapGetters({
      language: 'setting/getLanguage',
    }),
  },
  watch: {
    language() {
      this.$emit('updateHead')
    },
  },
  head: {
    title() {
      return {
        inner: this.$t(`pageTitle.${this.$route.name}`),
        complement: this.$t('siteId'),
      }
    },
  },
}
</script>
